import React from "react";
import { CheckCircle2, Mail, GraduationCap, Users } from "lucide-react";

const learningPoints = [
  "Die HELD-Regel: Hilfe rufen, Ermutigen & trösten, Lebenswichtige Funktionen prüfen, Decke unterlegen",
  "Notruf 112 — was sage ich, was tue ich",
  "Trösten als wichtigste Erste Hilfe",
  "Nasenbluten & Splitter im Finger versorgen",
  "Stabile Seitenlage Schritt für Schritt",
  'Was steckt im Erste-Hilfe-Koffer? („Ich packe meinen…")',
  "Unterschied: Unfall, Notfall, RTW & KTW",
];

export const Schools = () => {
  return (
    <section
      id="schulen"
      data-testid="schools-section"
      className="relative py-24 sm:py-32 bg-paula-red text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-20 -left-20 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-white/80 mb-4">
            Für Schulen & Kindergärten
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Erste Hilfe wird Unterricht —{" "}
            <span className="text-paula-yellow">spielerisch.</span>
          </h2>
          <p className="mt-6 text-white/85 text-lg leading-relaxed">
            Paula kommt nicht allein. Sie bringt eine durchdachte
            Lernbegleitung mit — entwickelt mit Pädagog:innen, getestet im
            Klassenraum, geliebt von Kindern.
          </p>

          <div className="mt-8 rounded-3xl bg-white/10 border border-white/20 p-6 backdrop-blur">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl bg-paula-yellow grid place-items-center">
                <Users className="text-paula-ink" size={22} />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-white/70">
                  Stolze Kooperation mit
                </div>
                <div className="font-display font-bold text-xl">
                  Kiwanis Club Solingen
                </div>
              </div>
            </div>
            <p className="mt-4 text-white/85 text-sm leading-relaxed">
              Gemeinsam mit dem Kiwanis Club Solingen bringen wir Paula in
              Klassenzimmer. Für jedes Kind, das etwas lernen — und etwas
              mitnehmen darf.
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-3xl bg-white text-paula-ink p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-2xl bg-paula-red-soft grid place-items-center">
                <GraduationCap className="text-paula-red" size={22} />
              </div>
              <h3 className="font-display font-bold text-2xl">
                Lerninhalte im Überblick
              </h3>
            </div>

            <ul className="space-y-3">
              {learningPoints.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 text-paula-ink/90"
                >
                  <CheckCircle2
                    className="text-paula-red flex-shrink-0 mt-0.5"
                    size={20}
                  />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-8 border-t border-slate-200">
              <div className="text-xs font-semibold uppercase tracking-widest text-paula-muted mb-3">
                Interesse für Ihre Einrichtung?
              </div>
              <a
                href="mailto:fallersimone@googlemail.com?subject=Paula%20f%C3%BCr%20unsere%20Schule"
                data-testid="schools-contact-cta"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-paula-ink text-white font-semibold hover:bg-paula-red transition-colors"
              >
                <Mail size={18} />
                Schul-Paket anfragen
              </a>
              <p className="mt-3 text-xs text-paula-muted">
                Wir melden uns innerhalb von 48 Stunden.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schools;
